import {ShowHide} from './Helpers'
import Axios from 'axios'

function formPathForTableauFetch(dashboardURL){
    let path = dashboardURL.split("/t/");
    let tableau = (path[0] === "https://analytics.csueastbay.edu") ? 'tableau' : (path[0] === "https://analyticstest.csueastbay.edu" ) ? 'tableau_test' : false;
    let parts = path[1].split("/");

    return {
        tableau: tableau,
        site: parts[0],
        workbook: parts[2],
        view: parts[3]
    }
}

let obj = {
    message:"Loading...",
    iFrameContent:"",
    lastContent:null,
    Content:null,
    load(params){
        let url = params.Content.DashboardURL;
        
        this.message = params.message || this.message;
        this.Content = params.Content;

        if(params.Content.DashboardType === 'tableau'){
            let get_vars = formPathForTableauFetch(url);
            url = "https://data.csueastbay.edu/data/fetch.tableau.url.php";
            url += "?tableau=" + get_vars.tableau;
            url += "&site=" + get_vars.site;
            url += "&workbook=" + get_vars.workbook;
            url += "&view=" + get_vars.view;
        }

        //For development, just load the tableau viz and log in separately
        if(process && process.env.NODE_ENV === 'development'){
            let tableau_params = (params.Content.DashboardType === 'tableau') ? "?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no" : "";
            this.iFrameContent = (this.Content.DashboardURL + tableau_params);
        } else {
            //For production, get a trusted URL from tableau server
            if(params.Content.DashboardType === 'tableau'){
                Axios.get(url)
                    .then(response => {
                        this.iFrameContent = response.data;
                    });            
            } else {
                //It's a pi-html-report; just fetch it
                this.iFrameContent = this.Content.DashboardURL;
            }
        }

        this.lastContent = params.Content.Path;
        this.show();
    },
    unload(){
        this.iFrameContent = "";
    }
};

obj = Object.assign(new ShowHide(false),obj);

export default obj;